<template>
  <v-app-bar app style="align-items: center;" :color="backgroundColor" :dark="dark">
    <v-btn icon @click="goBack">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-toolbar-title>Recent chats</v-toolbar-title>

    <v-spacer></v-spacer>

  </v-app-bar>

</template>

<script>
export default {
  name: "chatBotHeader",
  props: {
    backgroundColor: { type: String, required: true },
    dark: { type: Boolean, required: true },
    id_chatbot: { type: String, required: true }
  },
  data() {
    return {
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  watch: {
  },
};
</script>